import { render, staticRenderFns } from "./MatrList.vue?vue&type=template&id=f2337b70&scoped=true&"
import script from "./MatrList.vue?vue&type=script&lang=js&"
export * from "./MatrList.vue?vue&type=script&lang=js&"
import style0 from "./MatrList.vue?vue&type=style&index=0&id=f2337b70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2337b70",
  null
  
)

export default component.exports